<template>
	<main-page :user="user" color="yellow">
		<template v-slot:title>
			PROTOTYPES
		</template>

		<div class="container">
			<div class="row content">
				<div class="col-6 zone-padding">
					<a class="splash-button-link" href="#/prototypes">
						<img class="splash-button" src="@/assets/images/Prototype.png" />
					</a>
				</div>
				<div class="col-6 zone-padding d-flex flex-column">
					<h3 class="mt-0 mb-4">Select from the options below:</h3>
					<a
						v-if="user.role == 'STUDENT'"
						class="btn btn-lg btn-no-border btn-si-orange mb-5"
						href="#/upload_prototype"
					>
						Upload Prototype
					</a>
					<a class="btn btn-lg btn-no-border btn-si-blue mb-5" href="#/prototypes">
						View Prototypes
					</a>
					<a class="btn btn-lg btn-no-border btn-si-green mb-5" href="#/prototype_progress">
						View Reports
					</a>
				</div>
			</div>
		</div>

		<template v-slot:footer>
			<div class="col-6 text-right">
				<a class="btn btn-si-secondary" href="#/portfolio">Back</a>
			</div>
		</template>
	</main-page>
</template>

<script>
import MainPage from "@/components/MainPage";
import ProgramService from "@/services/ProgramService";

export default {
	name: "PitchEntry",

	props: ["user"],

	components: { MainPage },

	data() {
		return {
			program: null
		};
	},

	created() {
		ProgramService.getContextProgram()
			.then((r) => {
				this.program = r.data;
				console.log(this.program)
			})
			.catch((e) => {
				console.error(e);
			});
	},

	methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
	margin-top: 3rem;
	margin-bottom: 3rem;
}
.zone-padding {
	padding: 3rem;
}
.splash-button-link > img {
	transition: transform 0.15s ease-in-out;
}
.splash-button-link:hover > img {
	transform: scale(1.05);
}
.splash-button {
	width: 100%;
}
</style>
